import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormListModel } from 'src/app/services/forms/form-list-model';
import { FormsService } from 'src/app/services/forms/forms.service';
import { MessageService } from 'src/app/services/message.service';
import { SubmenuService } from '../../submenu/submenu.service';

@Component({
  selector: 'app-form-list',
  templateUrl: './form-list.component.html',
  styleUrls: ['./form-list.component.less']
})
export class FormListComponent implements OnInit {

  page:number = 1;
  componentData: FormListModel | undefined;
  
  constructor(public formsService: FormsService, public messageService:MessageService, public submenuService:SubmenuService, private router: Router) 
  { 
    
  }

  ngOnInit(): void {
    
    this.messageService.showLoading();
    this.formsService.loadFormsPage(this.page).subscribe((data:FormListModel) => {
        this.componentData = data;
        console.log(this.componentData);
        console.log(this.componentData.Layouts[0].HttpAlias);
        this.messageService.hideLoading();
    },    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordList("/forms");    
  }

  openEditor(item){
    var furl = "/dynamicforms/edit/"+item.FormId+"-"+item.ViewName+"-Edit";
    this.router.navigate(['/editor'], {queryParams:{formurl: furl}});
  }

  openEditorPF(item){
    var furl = "/dynamicforms/edit/"+item.Id+"-"+item.ViewName+"-Edit?isParameterForm=true";
    this.router.navigate(['/editor'], {queryParams:{formurl: furl}});
  }
}
